<template>
    <div class="settings-container">
        <label for="instruct_text" class="instruct-label">
            Voice Instructions:
        </label>
        <textarea id="instruct_text" v-model="localConfig.instruct_text" @input="emitUpdate"
            placeholder="How would you describe your voices?" class="instruct-textarea"></textarea>
    </div>
</template>

<script>
import { defineComponent, reactive, watch } from 'vue';

export default defineComponent({
    name: 'SettingsCosyVoice2',
    props: {
        config: { type: Object, required: true }
    },
    emits: ['update:config'],
    setup(props, { emit }) {
        const DEFAULT_INSTRUCT = '';

        let localConfig = reactive({ instruct_text: DEFAULT_INSTRUCT });

        watch(
            () => props.config.instruct_text,
            (val) => {
                localConfig.instruct_text = val ?? DEFAULT_INSTRUCT;
            },
            { immediate: true }
        );

        function emitUpdate() {
            emit('update:config', localConfig);
        }

        watch(
            () => localConfig.instruct_text,
            emitUpdate
        );

        return { localConfig, emitUpdate };
    }
});
</script>

<style scoped>
.settings-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    padding: 1rem;
    min-width: 300px;
}

.instruct-label {
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #333;
}

.instruct-textarea {
    flex: 1 1 auto;
    width: 100%;
    padding: 0.75rem;
    font-size: 1rem;
    font-family: inherit;
    line-height: 1.4;
    border: 1px solid #ccc;
    border-radius: 6px;
    resize: none;
    overflow: auto;
}

.instruct-textarea::placeholder {
    color: #aaa;
}
</style>